module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt":{"form_select.select":"Selecione"},"en":{"form_select.select":"Select"}}')
  delete Component.options._Ctor
}
